import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { featureFlagsApi } from "../services/feature-flags/feature-flags.service";
import activeFeatureFlagsSlice from "./active-feature-flags/index";
import cartSlice from "./cart";
import coursesSlice from "./courses";
import navigationSlice from "./navigation";
import sectionsSlice from "./sections";
import userSlice from "./user";

export const reducer = {
  user: userSlice,
  navigation: navigationSlice,
  sections: sectionsSlice,
  cart: cartSlice,
  courses: coursesSlice,
  activeFeatureFlags: activeFeatureFlagsSlice,
  [featureFlagsApi.reducerPath]: featureFlagsApi.reducer
};

export const middleware = (getDefaultMiddleware: any) => getDefaultMiddleware().concat(featureFlagsApi.middleware);
export const store = configureStore({
  reducer: {
    user: userSlice,
    navigation: navigationSlice,
    sections: sectionsSlice,
    cart: cartSlice,
    courses: coursesSlice,
    activeFeatureFlags: activeFeatureFlagsSlice,
    [featureFlagsApi.reducerPath]: featureFlagsApi.reducer
  },
  middleware: getDefaultMiddleware => getDefaultMiddleware().concat(featureFlagsApi.middleware),
  devTools: process.env.NODE_ENV === "development"
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
